import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CreditCard, X } from 'lucide-react';
import StoreAgencyAccount from './StoreAgencyAccount';
import './storeAgency.css';

export default function StoreAgencyAccountModal({ open, onClose, caps, accountResource }) {
  useEffect(() => {
    if (!open) return undefined;
    const bodyOverflow = document.body.style.overflow;
    const htmlOverflow = document.documentElement.style.overflow;
    const closeOnEscape = event => { if (event.key === 'Escape') onClose(); };
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    window.addEventListener('keydown', closeOnEscape);
    return () => {
      document.body.style.overflow = bodyOverflow;
      document.documentElement.style.overflow = htmlOverflow;
      window.removeEventListener('keydown', closeOnEscape);
    };
  }, [open, onClose]);

  if (!open) return null;
  return createPortal(<div className="sa-account-backdrop" role="presentation" onMouseDown={event => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="sa-account-modal" role="dialog" aria-modal="true" aria-labelledby="sa-account-title">
      <header><div><span><CreditCard size={22} /></span><div><h2 id="sa-account-title">QR para cobros contraentrega</h2><p>Configuración permanente de tu tienda</p></div></div>
        <button autoFocus aria-label="Cerrar configuración de QR" onClick={onClose}><X size={23} /></button></header>
      <div className="sa-account-modal-scroll"><div className="store-agency">
        <StoreAgencyAccount caps={caps} accountResource={accountResource} />
      </div></div>
    </section>
  </div>, document.body);
}
